import React from 'react';
import Modal from '../shared/Modal';

const ApproveGroceryListModal = props => {
  const { isOpen, closeModal, approved, onSubmit } = props;

  const heading = approved
    ? 'Update Approved Grocery List'
    : 'Approve Grocery List';
  const copy = approved
    ? 'Would you like to re-approve the grocery list? This will provide the Staff with a list of approve ingredients to buy for the service.'
    : 'Would you like to approve the grocery list? This will provide the Staff with a list of approve ingredients to buy for the service.';
  const cta = approved ? 'Update' : 'Approve';

  return (
    <Modal isOpen={isOpen} onRequestClose={closeModal}>
      <h2 className="h2 modal__heading">{heading}</h2>
      <div className="form__row--spacer">
        <div className="modal__p">
          <p className="p">{copy}</p>
        </div>
      </div>
      <div className="form__row">
        <div className="form__row-item--half">
          <div
            className="btn btn--hollow-red-bright btn--full-width"
            onClick={closeModal}
          >
            Cancel
          </div>
        </div>
        <div className="form__row-item--half">
          <div
            className="btn btn--solid-blue btn--full-width"
            onClick={onSubmit}
          >
            {cta}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ApproveGroceryListModal;



// WEBPACK FOOTER //
// ./src/components/groceryList/ApproveGroceryListModal.js